export default __webpack_public_path__ + "static/media/H1001.4.dc0a3f99.mp3";